// extracted by mini-css-extract-plugin
export default {"GiveawayModal":"GiveawayRulesModal_GiveawayModal__4EMe9","labelsContainer":"GiveawayRulesModal_labelsContainer__RvYe5","required":"GiveawayRulesModal_required__67muh"};